import styled from 'styled-components';

const ErrorMessage = styled.p`
  color: #eb1e32;

  margin: 3px 0;
`;

export default ErrorMessage;
